import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';


@Injectable({
	providedIn: 'root'
})
export class CartService {
	private cartChangedSource = new BehaviorSubject<void>(undefined);
	cartChanged$ = this.cartChangedSource.asObservable();

	private cartItemsSubject = new BehaviorSubject<any[]>([]);
	cartItems$ = this.cartItemsSubject.asObservable();

	private subtotalSubject = new BehaviorSubject<number>(0);
	subtotal$ = this.subtotalSubject.asObservable();

	private apiUrl = environment.apiUrl1 // replace with your API
	private progressSubject: BehaviorSubject<number>;
	constructor(private http: HttpClient) {
		const savedProgress = Number(localStorage.getItem('profile_status_percentage')) || 0;
		this.progressSubject = new BehaviorSubject<number>(savedProgress); // 👈 Load from localStorage
	}


	private getAuthHeaders(): HttpHeaders {
		const token = localStorage.getItem('token');
		return new HttpHeaders({
			'Authorization': `Bearer ${token}`,
			'Content-Type': 'application/json'
		});
	}

	/** Load cart from API */
	/** Load cart from API */
	loadCart(): Observable<any[]> {
		return this.http.get<any[]>(`${this.apiUrl}/api/cart`, { headers: this.getAuthHeaders() })
			.pipe(
				tap((items) => {
					this.cartItemsSubject.next(items);
					this.updateSubtotal(items);
				})
			);
	}


	/** Add item */
	addToCart(productId: number, businessAccountId: number, quantity: number): Observable<any> {
		const payload = { productId, businessAccountId, quantity };
		return this.http.post(`${this.apiUrl}/api/cart`, payload, { headers: this.getAuthHeaders() })
			.pipe(
				tap(() => {
					// fire event so components know the cart changed
					this.cartChangedSource.next();

					// optional: trigger loadCart to update any internal cache
					// this.loadCart().subscribe(); // only if you want to preload
				})
			);
	}

	/** Update quantity */
	updateQuantity(productId: number, businessAccountId: number, quantity: number) {
		const payload = { productId, businessAccountId, quantity };
		return this.http.put(`${this.apiUrl}/api/cart`, payload, { headers: this.getAuthHeaders() })
			.pipe(
				tap(() => this.loadCart()) // refresh after update
			)
			.subscribe();
	}

	/** Remove item */
	removeFromCart(cartId: number): Observable<any> {
		return this.http.delete(`${this.apiUrl}/api/cart/${cartId}`, {
			headers: this.getAuthHeaders()
		}).pipe(
			tap(() => {
				// refresh cart after delete
				this.loadCart().subscribe();
			})
		);
	}


	/** Recalculate subtotal */
	private updateSubtotal(items: any[]) {
		const total = items.reduce((sum, i) => sum + i.quantity * i.price, 0);
		this.subtotalSubject.next(total);
	}

	loadWishlist(): Observable<any[]> {
		return this.http.get<any[]>(`${this.apiUrl}/api/wishlist`, { headers: this.getAuthHeaders() })
	}

	addToWishlist(productId: number, businessAccountId: number, isNotify: boolean) {
		const payload = { productId, businessAccountId, isNotify };
		return this.http.post(`${this.apiUrl}/api/wishlist`, payload, { headers: this.getAuthHeaders() })
	}

	removeFromWishlist(cartId: number): Observable<any> {
		return this.http.delete(`${this.apiUrl}/api/wishlist/${cartId}`, {
			headers: this.getAuthHeaders()
		}).pipe(
			tap(() => {
				// refresh cart after delete
				this.loadCart().subscribe();
			})
		);
	}

	MoveToCart(wishlistId: number): Observable<any> {
		return this.http.post(`${this.apiUrl}/api/wishlist/move-to-cart/${wishlistId}`, {
			headers: this.getAuthHeaders()
		}).pipe(
			tap(() => {
				// refresh cart after delete
				this.loadCart().subscribe();
			})
		);
	}

	private cartCountSource = new BehaviorSubject<number>(0);
	cartCount$ = this.cartCountSource.asObservable();

	setCartCount(count: number) {
		this.cartCountSource.next(count);
	}

	incrementCartCount() {
		this.cartCountSource.next(this.cartCountSource.value + 1);
	}

	CreateOrder(payload: any) {
		return this.http.post(`${this.apiUrl}/api/orders`, payload)
	}

	getShippingMethods() {
		return this.http.get(`${this.apiUrl}/api/shippings`)
	}

	getAllOrders() {
		return this.http.get(`${this.apiUrl}/api/orders`)
	}
	getOrdersByid(id: number) {
		return this.http.get(`${this.apiUrl}/api/orders/${id}`)
	}

	deleterOrders(id: number) {
		return this.http.delete(`${this.apiUrl}/api/orders/${id}`)
	}

	UpdateOrders(id: number, payload: any) {
		return this.http.put(`${this.apiUrl}/api/orders/${id}`, payload)
	}

	UpdateOrderStatus(id: number) {
		return this.http.put(`${this.apiUrl}/api/orders/${id}/confirm`, id)
	}

	get progress$() {
		return this.progressSubject.asObservable();
	}

	setProgress(value: number) {
		this.progressSubject.next(value);
		localStorage.setItem('profile_status_percentage', value.toString()); // 👈 Keep localStorage synced
	}

	getProgress(): number {
		return this.progressSubject.value;
	}
}
